const doc = [({"da":({"js":({"admin":({"highscores":({"nav":({"communes":"Kommuner", "generations":"Genereringer", "regions":"Regioner"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;